import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import {
    productDescription as productDescriptionSelector,
    productOverview as productOverviewSelector,
} from 'ggApp/modules/product/selectors';
import { Hr } from '../Common';

import { Description } from './styled';

// export for tests
export const ProductDescriptionComponent = ({ className, description, productOverview }) => {
    const { short_description: shortDescription } = productOverview || {};
    return description || shortDescription ? (
        <>
            <Description
                className={className}
                shortDescription={shortDescription}
                productText={description}
            />
            <Hr />
        </>
    ) : null;
};

ProductDescriptionComponent.propTypes = {
    className: PropTypes.string,
    description: PropTypes.shape({
        title: PropTypes.string,
        text: PropTypes.string,
    }),
    productOverview: PropTypes.shape({
        short_description: PropTypes.string,
    }),
};

ProductDescriptionComponent.defaultProps = {
    className: undefined,
    description: undefined,
    productOverview: undefined,
};

const enhanced = connect(
    createStructuredSelector({
        description: productDescriptionSelector,
        productOverview: productOverviewSelector,
    }),
    null,
)(ProductDescriptionComponent);
export { enhanced as ProductDescription };
